'use client';

import React from 'react';

import Link from 'next/link';

const ConditionerLinkComp = ({
  children,
  href,
  isLink,
  className,
}: {
  className?: string;
  children: React.ReactNode;
  href: string;
  isLink: boolean;
}) => {
  if (isLink) return <div className={className}>{children}</div>;
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
};

export default ConditionerLinkComp;
